import React from 'react';
import { Card, Button, Form, Input, message, Descriptions, Spin } from 'antd';
import Title from '../../component/title';
import Fetch from '../../Fetch';

const Wa = props => {
    const [status, setStatus] = React.useState(null);
    const [phone, setPhone] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [submitting, setSubmitting] = React.useState(false);
    const intervalRef = React.useRef(null);

    const fetchStatus = async () => {
        try {
            const data = await Fetch.get('/wa');
            console.log(data)
            setStatus(data);
        } catch (e) {
            message.error('Gagal mengambil status WhatsApp');
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        fetchStatus();
    }, []);

    React.useEffect(() => {
        if (status && status.status === 'process') {
            intervalRef.current = setInterval(fetchStatus, 1000);
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [status && status.status]);

    const handleConnect = async () => {
        if (!phone) {
            message.error('Nomor telepon harus diisi');
            return;
        }
        setSubmitting(true);
        try {
            await Fetch.post('/wa', { phone });
            message.success('Permintaan koneksi dikirim');
            setLoading(true);
            await fetchStatus();
        } catch (e) {
            message.error('Gagal menghubungkan WhatsApp');
        } finally {
            setSubmitting(false);
        }
    };

    const handleLogout = async () => {
        setSubmitting(true);
        try {
            await Fetch.del('/wa');
            message.success('Berhasil logout WhatsApp');
            setLoading(true);
            await fetchStatus();
        } catch (e) {
            message.error('Gagal logout WhatsApp');
        } finally {
            setSubmitting(false);
        }
    };

    const renderContent = () => {
        if (loading) return <Spin />;
        if (!status || status.status === 'none') {
            return (
                <div style={{ maxWidth: 400 }}>
                    <p style={{ color: '#8c8c8c', marginBottom: 16 }}>Belum ada nomor WhatsApp yang terhubung.</p>
                    <Form layout="vertical">
                        <Form.Item label="Nomor Telepon">
                            <Input
                                value={phone}
                                onChange={e => setPhone(e.target.value)}
                                placeholder="Contoh: 628123456789"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                onClick={handleConnect}
                                loading={submitting}
                                style={{ borderRadius: 6, height: 38, fontWeight: 600 }}
                            >
                                Hubungkan
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            );
        }

        if (status.status === 'process') {
            return (
                <div>
                    <p style={{ color: '#8c8c8c', marginBottom: 16 }}>Proses koneksi sedang berlangsung. Masukkan kode berikut di WhatsApp Anda.</p>
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label="Nomor Telepon">{status.phone}</Descriptions.Item>
                        <Descriptions.Item label="Kode">
                            <span style={{ fontSize: 24, fontWeight: 700, color: '#389e0d', letterSpacing: 4 }}>
                                {status.code}
                            </span>
                        </Descriptions.Item>
                    </Descriptions>
                    <p style={{ marginTop: 16, color: '#8c8c8c' }}>
                        <Spin size="small" style={{ marginRight: 8 }} />
                        Menunggu konfirmasi...
                    </p>
                </div>
            );
        }

        if (status.status === 'logged_in') {
            return (
                <div>
                    <Descriptions column={1} bordered style={{ marginBottom: 16 }}>
                        <Descriptions.Item label="Status">
                            <span style={{ color: '#52c41a', fontWeight: 600 }}>Terhubung</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="Nomor Telepon">{status.phone}</Descriptions.Item>
                    </Descriptions>
                    <Button
                        type="danger"
                        onClick={handleLogout}
                        loading={submitting}
                        style={{ borderRadius: 6, height: 38, fontWeight: 600 }}
                    >
                        Logout WhatsApp
                    </Button>
                </div>
            );
        }

        return null;
    };

    return (
        <Card title={<Title title="Koneksi WhatsApp" />}>
            {renderContent()}
        </Card>
    );
};

export default Wa;